try {
  if (/win/i.test(navigator.platform)) {
    document.getElementById('root').classList.add('windows')
  }
} catch (_) {}
